"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/SVFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_216)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_216`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 0.000305176H30V23.9998H-6V0.000305176Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 0.000305176H30V8.00012H-6V0.000305176ZM-6 16H30V23.9998H-6V16Z",
					fill: "#0052B4"
				}),
				/* @__PURE__ */ n("path", {
					d: "M10.0723 12.4174L12.0001 9.07831L13.9279 12.4174H10.0723Z",
					fill: "#FFDA44"
				}),
				/* @__PURE__ */ n("path", {
					d: "M14.5044 13.5199L12.0001 14.7721L9.49585 13.5199V11.8504H14.5044V13.5199Z",
					fill: "#6DA544"
				}),
				/* @__PURE__ */ n("path", {
					d: "M14.361 9.22162L13.4756 10.107C13.8532 10.4847 14.0868 11.0064 14.0868 11.5827C14.0868 12.7353 13.1525 13.6696 12 13.6696C10.8474 13.6696 9.91309 12.7352 9.91309 11.5827C9.91309 11.0065 10.1467 10.4847 10.5243 10.107L9.63894 9.22162C9.03467 9.82588 8.66089 10.6606 8.66089 11.5826C8.66089 13.4268 10.1558 14.9217 12 14.9217C13.8441 14.9217 15.339 13.4268 15.339 11.5826C15.339 10.6606 14.9653 9.82574 14.361 9.22162Z",
					fill: "#FFDA44"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_216`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as SVFlag };
